import GenericDB from './generic-db';

export default class SessionGroupsDb extends GenericDB {
  constructor() {
    super('sessionGroups');
  }
}
